import {
  ConversationStarter,
  Question,
  Vocabulary,
  LanguageData,
} from '../types/data';

/**
 * Vocabulary
 * 10 most used words per difficulty level
 */
const vocabulary: Vocabulary[] = [
  // Beginner level
  {
    word: 'hello',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'thank you',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'please',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'yes',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'no',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'water',
    tags: ['FoodAndDrink', 'DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'food',
    tags: ['FoodAndDrink'],
    difficulty: 'Beginner',
  },
  {
    word: 'bathroom',
    tags: ['Travel', 'DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'good morning',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },
  {
    word: 'goodbye',
    tags: ['DailyLife'],
    difficulty: 'Beginner',
  },

  // Intermediate level
  {
    word: 'perhaps',
    tags: ['DailyLife'],
    difficulty: 'Intermediate',
  },
  {
    word: 'nevertheless',
    tags: ['DailyLife', 'Education'],
    difficulty: 'Intermediate',
  },
  {
    word: 'whereas',
    tags: ['DailyLife', 'Education'],
    difficulty: 'Intermediate',
  },
  {
    word: 'according to',
    tags: ['Business', 'Education'],
    difficulty: 'Intermediate',
  },
  {
    word: 'although',
    tags: ['DailyLife', 'Education'],
    difficulty: 'Intermediate',
  },
  {
    word: 'acquire',
    tags: ['DailyLife', 'Business'],
    difficulty: 'Intermediate',
  },
  {
    word: 'develop',
    tags: ['Business', 'Technology'],
    difficulty: 'Intermediate',
  },
  {
    word: 'however',
    tags: ['Education', 'Business'],
    difficulty: 'Intermediate',
  },
  {
    word: 'furthermore',
    tags: ['Education', 'Business'],
    difficulty: 'Intermediate',
  },
  {
    word: 'establish',
    tags: ['Business', 'Education'],
    difficulty: 'Intermediate',
  },

  // Advanced level
  {
    word: 'indispensable',
    tags: ['Business', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'notwithstanding',
    tags: ['DailyLife', 'Business', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'simultaneously',
    tags: ['Education', 'Technology'],
    difficulty: 'Advanced',
  },
  {
    word: 'unequivocally',
    tags: ['Education', 'Business'],
    difficulty: 'Advanced',
  },
  {
    word: 'superfluous',
    tags: ['Business', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'vindicate',
    tags: ['Business', 'CurrentEvents'],
    difficulty: 'Advanced',
  },
  {
    word: 'disparage',
    tags: ['DailyLife', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'elucidate',
    tags: ['Business', 'Education'],
    difficulty: 'Advanced',
  },
  {
    word: 'contemplative',
    tags: ['Literature', 'Arts'],
    difficulty: 'Advanced',
  },
  {
    word: 'idiosyncrasy',
    tags: ['Culture', 'Education'],
    difficulty: 'Advanced',
  },
];

/**
 * Suggested Questions
 * 10 most used questions per difficulty level
 */
const suggestedQuestions: Question[] = [
  // Beginner level
  {
    question: 'What is your name?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: 'Where are you from?',
    difficulty: 'Beginner',
    tags: ['DailyLife', 'Travel'],
  },
  {
    question: 'What time is it?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: 'Where is the bathroom?',
    difficulty: 'Beginner',
    tags: ['Travel', 'DailyLife'],
  },
  {
    question: 'How much does this cost?',
    difficulty: 'Beginner',
    tags: ['Travel', 'FoodAndDrink', 'DailyLife'],
  },
  {
    question: 'Do you speak English?',
    difficulty: 'Beginner',
    tags: ['Travel', 'DailyLife'],
  },
  {
    question: 'How are you?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: 'What is this?',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    question: 'Do you have water?',
    difficulty: 'Beginner',
    tags: ['FoodAndDrink', 'DailyLife'],
  },
  {
    question: 'Where is the hotel?',
    difficulty: 'Beginner',
    tags: ['Travel'],
  },

  // Intermediate level
  {
    question: 'What do you like to do in your free time?',
    difficulty: 'Intermediate',
    tags: ['DailyLife', 'Hobbies'],
  },
  {
    question: 'What is your favorite movie and why?',
    difficulty: 'Intermediate',
    tags: ['Entertainment', 'DailyLife'],
  },
  {
    question: 'How do you usually get to work?',
    difficulty: 'Intermediate',
    tags: ['DailyLife', 'Travel'],
  },
  {
    question: 'What kind of music do you prefer to listen to?',
    difficulty: 'Intermediate',
    tags: ['Music', 'Entertainment'],
  },
  {
    question: 'Could you recommend a good restaurant nearby?',
    difficulty: 'Intermediate',
    tags: ['FoodAndDrink', 'Travel'],
  },
  {
    question: 'What do you think about the current political situation?',
    difficulty: 'Intermediate',
    tags: ['CurrentEvents', 'Culture'],
  },
  {
    question: 'How has your city changed in recent years?',
    difficulty: 'Intermediate',
    tags: ['Culture', 'DailyLife'],
  },
  {
    question: 'What would you do if you won the lottery?',
    difficulty: 'Intermediate',
    tags: ['DailyLife'],
  },
  {
    question: 'Have you traveled anywhere interesting recently?',
    difficulty: 'Intermediate',
    tags: ['Travel', 'DailyLife'],
  },
  {
    question: 'What are your goals for the next year?',
    difficulty: 'Intermediate',
    tags: ['DailyLife', 'Business'],
  },

  // Advanced level
  {
    question:
      'How do you think artificial intelligence will transform our society in the coming decades?',
    difficulty: 'Advanced',
    tags: ['Technology', 'CurrentEvents', 'Science'],
  },
  {
    question:
      'What measures do you consider most effective for combating climate change at both individual and governmental levels?',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Science', 'Education'],
  },
  {
    question:
      'In what ways has globalization affected cultural identities in your country?',
    difficulty: 'Advanced',
    tags: ['Culture', 'CurrentEvents', 'Business'],
  },
  {
    question:
      'What is your stance on the balance between personal privacy and national security in the digital age?',
    difficulty: 'Advanced',
    tags: ['Technology', 'CurrentEvents'],
  },
  {
    question:
      'How has your perspective on education evolved throughout your life?',
    difficulty: 'Advanced',
    tags: ['Education', 'DailyLife'],
  },
  {
    question:
      'What role should art play in an increasingly technology-oriented society?',
    difficulty: 'Advanced',
    tags: ['Arts', 'Technology', 'Culture'],
  },
  {
    question:
      'To what extent do you believe media influences the formation of public opinion?',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Technology'],
  },
  {
    question:
      'How would you approach an ethical dilemma where your personal values conflict with your professional responsibilities?',
    difficulty: 'Advanced',
    tags: ['Business', 'Education'],
  },
  {
    question:
      'In what ways do you think literature both reflects and shapes the values of a society?',
    difficulty: 'Advanced',
    tags: ['Literature', 'Culture', 'Education'],
  },
  {
    question:
      'What are the most significant challenges facing contemporary democracies?',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Education'],
  },
];

/**
 * Conversation Starters
 * 10 most used conversation starters per difficulty level
 */
const conversationStarters: ConversationStarter[] = [
  // Beginner level
  {
    sentence: 'I really like English food.',
    difficulty: 'Beginner',
    tags: ['FoodAndDrink', 'Culture'],
  },
  {
    sentence: 'The weather is very nice today.',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    sentence: 'My family is from London.',
    difficulty: 'Beginner',
    tags: ['DailyLife', 'Travel'],
  },
  {
    sentence: 'I love traveling around England.',
    difficulty: 'Beginner',
    tags: ['Travel', 'DailyLife'],
  },
  {
    sentence: 'I am learning English.',
    difficulty: 'Beginner',
    tags: ['Education', 'DailyLife'],
  },
  {
    sentence: 'I would like to practice my English.',
    difficulty: 'Beginner',
    tags: ['Education', 'DailyLife'],
  },
  {
    sentence: 'I live in a small city.',
    difficulty: 'Beginner',
    tags: ['DailyLife'],
  },
  {
    sentence: 'I like listening to English music.',
    difficulty: 'Beginner',
    tags: ['Music', 'Culture'],
  },
  {
    sentence: 'I work as a teacher.',
    difficulty: 'Beginner',
    tags: ['DailyLife', 'Education'],
  },
  {
    sentence: 'My favorite sport is soccer.',
    difficulty: 'Beginner',
    tags: ['Sports', 'DailyLife'],
  },

  // Intermediate level
  {
    sentence:
      'Lately I have been thinking about moving to an English-speaking country to improve my English.',
    difficulty: 'Intermediate',
    tags: ['Travel', 'Education', 'DailyLife'],
  },
  {
    sentence:
      'British cuisine is very diverse, each region has its traditional dishes.',
    difficulty: 'Intermediate',
    tags: ['FoodAndDrink', 'Culture', 'Travel'],
  },
  {
    sentence:
      'I would love to learn more about the history and culture of English-speaking countries.',
    difficulty: 'Intermediate',
    tags: ['Culture', 'Education', 'Travel'],
  },
  {
    sentence:
      'I think British cinema has very talented directors like Christopher Nolan and Ken Loach.',
    difficulty: 'Intermediate',
    tags: ['Entertainment', 'Culture', 'Arts'],
  },
  {
    sentence:
      'I have noticed that there are many differences between British English and American English.',
    difficulty: 'Intermediate',
    tags: ['Culture', 'Education'],
  },
  {
    sentence: 'I am reading a novel by Jane Austen to improve my vocabulary.',
    difficulty: 'Intermediate',
    tags: ['Literature', 'Education'],
  },
  {
    sentence:
      'I would like to visit the British Museum the next time I go to London.',
    difficulty: 'Intermediate',
    tags: ['Travel', 'Arts', 'Culture'],
  },
  {
    sentence:
      'In my opinion, learning languages is one of the best ways to understand different cultures.',
    difficulty: 'Intermediate',
    tags: ['Education', 'Culture'],
  },
  {
    sentence:
      'I have always wanted to attend the Edinburgh Festival in Scotland.',
    difficulty: 'Intermediate',
    tags: ['Travel', 'Culture', 'Entertainment'],
  },
  {
    sentence:
      'English literature has produced many influential writers throughout history.',
    difficulty: 'Intermediate',
    tags: ['Literature', 'Culture', 'Education'],
  },

  // Advanced level
  {
    sentence:
      'The linguistic diversity within the English language, with its numerous dialects and regional variations, reflects the cultural richness of English-speaking countries and raises interesting questions about linguistic identity.',
    difficulty: 'Advanced',
    tags: ['Culture', 'Education', 'CurrentEvents'],
  },
  {
    sentence:
      'The works of Shakespeare have had an immeasurable influence on world literature and continue to be reinterpreted and reimagined in countless ways across different cultures and media.',
    difficulty: 'Advanced',
    tags: ['Literature', 'Arts', 'Culture'],
  },
  {
    sentence:
      'The transition from the British Empire to the Commonwealth represents a complex historical process that continues to shape international relations and cultural exchanges today.',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Education', 'Culture'],
  },
  {
    sentence:
      'The phenomenon of urban gentrification in major English-speaking cities raises important questions about social equity, cultural preservation, and sustainable urban development.',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Culture', 'Business'],
  },
  {
    sentence:
      'The global dominance of English as a lingua franca has profound implications for international business, education, and cultural exchange, while also raising concerns about linguistic diversity and cultural imperialism.',
    difficulty: 'Advanced',
    tags: ['Culture', 'CurrentEvents', 'Education'],
  },
  {
    sentence:
      "The Industrial Revolution, which began in Britain, fundamentally transformed not only economic systems but also social structures, urban landscapes, and humanity's relationship with the natural environment.",
    difficulty: 'Advanced',
    tags: ['Culture', 'Education', 'Technology'],
  },
  {
    sentence:
      'The philosophical tradition of empiricism, developed by thinkers like Locke and Hume, has profoundly influenced scientific methodology, political theory, and our understanding of human knowledge.',
    difficulty: 'Advanced',
    tags: ['Education', 'Science', 'Culture'],
  },
  {
    sentence:
      'The evolution of the Westminster parliamentary system has provided a model of democratic governance that has been adapted and modified in numerous countries around the world.',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Education', 'Culture'],
  },
  {
    sentence:
      'The modernist literary movement, with figures like James Joyce and Virginia Woolf, revolutionized narrative techniques and explored the complexities of human consciousness in ways that continue to influence contemporary fiction.',
    difficulty: 'Advanced',
    tags: ['Literature', 'Arts', 'Culture'],
  },
  {
    sentence:
      'The concept of "soft power," exemplified by the global influence of English-language media, entertainment, and educational institutions, demonstrates how cultural and ideological influence can be as significant as economic or military might.',
    difficulty: 'Advanced',
    tags: ['CurrentEvents', 'Culture', 'Education'],
  },
];

export const english: LanguageData = {
  vocabulary,
  suggestedQuestions,
  conversationStarters,
};
